const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('flarum-flags', 'forum/components/FlagList');